import { TourTypeURL } from '@/_models/Tour';

const getSlugFromUrl = (url: string): string => {
  try {

    const pathname = new URL(url).pathname;
    const pathSegments = pathname.split('/').filter(Boolean);

    const tourIndex = pathSegments.findIndex(segment =>
      segment === TourTypeURL.regular ||
      segment === TourTypeURL.experience ||
      segment === TourTypeURL.ecommerce ||
      segment === TourTypeURL.kiosk
    );

    if (tourIndex === -1 || tourIndex + 1 >= pathSegments.length) return '';

    return pathSegments[tourIndex + 1];
  } catch (error) {
    return '';
  }
};

export default getSlugFromUrl;
